export default __webpack_public_path__ + "static/media/mapaSP.0a8ebfd5.jpeg";